
import type { DefineComponent } from 'vue'
import { defineComponent } from 'vue'
import EpbModalDialog from './epb-modal-dialog.component.vue'

export default defineComponent({
  name: 'EpbModalWrapper',
  components: {
    EpbModalDialog,
  },
  props: (EpbModalDialog as unknown as DefineComponent).props,
  emits: {
    close: () => {},
  },
  setup: () => {
    return {
      baseClass: 'epb-modal',
    }
  },
})
